/**
 * FeaturedCarousel — Manual image carousel with labeled placeholder slides.
 */
import React, { useState, useEffect, useCallback } from 'react';
import styles from './FeaturedCarousel.module.css';

const SLIDES = [
  'Replace: Robot at Worlds 2025',
  'Replace: Build season workshop',
  'Replace: Competition match action',
  'Replace: Outreach event photo',
  'Replace: Team photo — full roster',
  'Replace: Robot reveal still',
];

const AUTOPLAY_MS = 8000;

function FeaturedCarousel() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  const go = useCallback((next) => {
    setIndex((i) => (next + SLIDES.length) % SLIDES.length);
  }, []);

  useEffect(() => {
    if (paused) return undefined;
    const id = setInterval(() => go(1), AUTOPLAY_MS);
    return () => clearInterval(id);
  }, [paused, go]);

  return (
    <div
      className={styles.carousel}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocus={() => setPaused(true)}
      onBlur={() => setPaused(false)}
    >
      <div
        className={styles.track}
        style={{ transform: `translateX(-${index * 100}%)` }}
      >
        {SLIDES.map((label) => (
          <div key={label} className={styles.slide}>
            <span className={styles.label}>{label}</span>
          </div>
        ))}
      </div>

      <div className={styles.controls}>
        <div className={styles.arrows}>
          <button
            type="button"
            className={styles.arrowBtn}
            aria-label="Previous slide"
            onClick={() => go(-1)}
          >
            ←
          </button>
          <button
            type="button"
            className={styles.arrowBtn}
            aria-label="Next slide"
            onClick={() => go(1)}
          >
            →
          </button>
        </div>

        <div className={styles.dots} role="tablist" aria-label="Carousel slides">
          {SLIDES.map((label, i) => (
            <button
              key={label}
              type="button"
              role="tab"
              aria-selected={i === index}
              aria-label={`Slide ${i + 1}`}
              className={`${styles.dot} ${i === index ? styles.dotActive : ''}`}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default FeaturedCarousel;
